import React from "react";

const KeypadRow = props => <div className={`keypad-row ${props.customStyle ? props.customStyle : ''}`}>{props.children}</div>;

export default KeypadRow;
